import React, { Component } from "react";
import { Accordion } from "react-bootstrap";
import _ from "lodash";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { imageUrl } from "../actions/miscAction";

const closeIcon = imageUrl("close-icon.svg");

class pipeFilterSidebar extends Component {
  state = {
    filtersShow: 6,
    od: "",
    wt: "",
    weight: "",
    unitMeasure: 0,
    length: "",
    nrofPipes: "",
    totalLength: "",
    averageJoin: "",
    totalWeight: "",
    scrap: "",
    totalScrap: "",
    defaultActiveKey: ["0"],
  };

  handleToggle = (id) => {
    const { defaultActiveKey } = this.state;
    const findId = defaultActiveKey.find((key) => key === id);
    if (findId) {
      this.setState({
        defaultActiveKey: defaultActiveKey.filter((key) => key !== id),
      });
    } else {
      const newData = [...defaultActiveKey, ...[id]];
      this.setState({ defaultActiveKey: newData });
    }
  };

  componentDidMount() {
    const script = document.createElement("script");

    script.src =
      "https://www.barchart.com/widget.js?uid=7c97d40cc2f911361b1bb3050a800ab4&widgetType=chart&showChart=true&widgetWidth=214&chartType=AREA&chartColor[area]=46ad1d&fontColor[links]=46ad1d&font=1&animated=1&symbols[]=xom&fields[]=name&fields[]=last&fields[]=change&displayChars";
    script.async = true;

    document.body.appendChild(script);
  }
  showMore = (counts, data, type) => {
    this.props.filterModalDataCounts(counts);
    this.props.filterModalData(data);
    this.props.toggleFilter();
    this.props.modalType(type);
  };

  calculateScrap = () => {
    const length = this.state.length;
    const nrofPipes = this.state.nrofPipes;
    const weight = this.state.weight;
    var scrapprice = this.state.scrap;

    const constant = this.state.unitMeasure ? 1000 : 2204.6;

    if (!scrapprice) {
      scrapprice = 200;
    } else {
      scrapprice = parseFloat(this.state.scrap);
    }

    try {
      // H= B*E*F/ 2204.6
      var result = ((scrapprice * weight * length * nrofPipes) / constant).toFixed(2);
      result = result.replace(/^0\.*/, ".");
    } catch (err) {
      result = "";
    }
    result = isNaN(result) ? "" : result;
    this.setState({ totalScrap: result });
  };

  calculateTotalWeight = () => {
    const length = this.state.length;
    const nrofPipes = this.state.nrofPipes;
    const weight = this.state.weight;
    const totalLength = this.state.totalLength;

    const constant = this.state.unitMeasure ? 1000 : 2204.6;

    try {
      // H= B*E*F/ 2204.6
      if (totalLength) {
        var result = ((weight * totalLength) / constant).toFixed(2);
      } else {
        result = ((weight * length * nrofPipes) / constant).toFixed(2);
      }

      result = result.replace(/^0\.*/, ".");
    } catch (err) {
      result = "";
    }
    result = isNaN(result) ? "" : result;
    this.setState({ totalWeight: result });
  };

  calctotalJoin = () => {
    const totalLength = parseFloat(this.state.totalLength);
    const nrofPipes = parseFloat(this.state.nrofPipes);
    var result = "";

    try {
      result = (totalLength / nrofPipes).toFixed(2);
      result = result.replace(/^0\.*/, ".");
    } catch (err) {
      result = "";
    }
    result = isNaN(result) ? "" : result;
    this.setState({ averageJoin: result });
  };

  calctotalLength = () => {
    const length = parseFloat(this.state.length);
    const nrofPipes = parseFloat(this.state.nrofPipes);
    var result = "";

    try {
      result = (length * nrofPipes).toFixed(2);
      result = result.replace(/^0\.*/, ".");
    } catch (err) {
      result = "";
    }
    result = isNaN(result) ? "" : result;
    this.setState({ totalLength: result });
  };

  toDecimal(_x) {
    var parts = _x.split(" ");

    if (parts.length > 2 || isNaN(parts[0])) {
      alert("Outer Diameter must be entered as a fraction.");
      return 0;
    }

    // if no second element, then must be a whole number
    if (!parts[1]) {
      return _x;
    }

    var decParts = parts[1].split("/");
    return parseInt(parts[0], 10) + parseInt(decParts[0], 10) / parseInt(decParts[1], 10);
  }

  calculateWeightOf = () => {
    const od = this.state.od;
    const wt = parseFloat(this.state.wt);
    const um = this.state.unitMeasure;

    const s = um ? od : this.toDecimal(od);

    const constant = um ? 0.0246421502959472 : 10.69;

    // wt provided
    if (wt) {
      try {
        // B=10.69*(A-C)*C
        var result = (constant * (s - wt) * wt).toFixed(3);
        result = result.replace(/^0\.*/, ".");
      } catch (err) {
        result = "";
      }
      result = isNaN(result) ? "" : result;

      this.setState({ weight: result });
    } else {
      alert("Wall Thickness is required for calculating weight");
    }
  };

  calculateWt = () => {
    const od = this.state.od;
    const weight = this.state.weight;

    const um = this.state.unitMeasure;

    const s = um ? od : this.toDecimal(od);
    const w = weight;

    const constant = um ? 0.0246421502959472 : 10.69;

    // weight provided
    if (weight) {
      try {
        var result = ((s - Math.sqrt(Math.pow(s, 2) - (4 / constant) * w)) / 2).toFixed(3);
        result = result.replace(/^0\.*/, ".");
      } catch (err) {
        result = "";
      }
      result = isNaN(result) ? "" : result;
      this.setState({ wt: result });
    } else {
      alert("Weight is required for calculating Wall thinkness");
    }
  };

  render() {
    const {
      catagory,
      catagory1,
      make,
      model,
      region,
      removeFilter,
      saleType,
      pipeType,
      pipeCondition,
      pipeMillCert,
      pipeSize,
      pipeMaterial,
      loadingMain,
    } = this.props;
    const { facets } = this.props;
    const sale_type = facets["pipe.sale_type"] && Object.keys(facets["pipe.sale_type"]);
    const pipe_type = facets["pipe.sale_type"] && Object.keys(facets["pipe.pipe_type"]);
    const pipe_condition = facets["pipe.pipe_condition"] && Object.keys(facets["pipe.pipe_condition"]);
    const pipe_mill_cert = facets["pipe.pipe_mill_cert"] && Object.keys(facets["pipe.pipe_mill_cert"]);

    const pipe_size = facets["pipe.pipe_size"] && Object.keys(facets["pipe.pipe_size"]);

    const pipe_size_asc_dev = [
      "1",
      "1 1/2",
      "1 3/4",
      "1 9/10",
      "2",
      "2 1/16",
      "2 3/8",
      "2 7/8",
      '2 7/8" 2 3/8',
      "3 1/2",
      "4",
      "4 1/2",
      "4 - 8",
      "4 1/2''",
      "4 3/4",
      '4 1/2" - 5 1/2',
      "5",
      "5 1/2",
      "5 7/8",
      "5.5",
      "6",
      "6 5/8",
      "7",
      "7 5/8",
      "8",
      "8 5/8",
      "9 3/8",
      "9 5/8",
      "9 7/8",
      "9 5/6",
      '9 5/8" - 14"',
      "10",
      "10 1/4",
      "10 3/4",
      "10 3/4 - 13 3/8",
      "11 3/4",
      "11 13/16",
      "11 7/8",
      "12",
      "12 3/4",
      "13 3/8",
      "13 5/8",
      "14",
      "16",
      "16 3/4",
      "17",
      "17 7/8",
      "18",
      "18 5/8",
      "20",
      "22",
      "24",
      "24 1/2",
      "26",
      "30",
      "32",
      "36",
      "42",
      "48",
    ];

    const pipe_size_asc_prod = [
      "1",
      "1 4/13",
      "1 1/4",
      "1 2/3",
      "1 1/4 - 2 7/8",
      '1 1/2" - 3 1/2',
      '1/2" - 16',
      "2 1/16",
      "2.394",
      "2 1/2",
      "2 3/8",
      "2 7/8",
      '2 3/8" - 2 7/8',
      '2 3/8" - 3 1/2',
      '2 3/8" - 4 1/2',
      '2 3/8" - 9 5/8',
      '2 3/4" - 9 5/8',
      "3",
      "3 1/8",
      "3 6/13",
      "3 1/2",
      "4",
      "4 1/2",
      "4 1//2",
      '4" - 6 5/8',
      '4 1/2" - 8 5/8',
      '4 1/2" - 13 3/8',
      "5",
      "5 1/2",
      "5 7/8",
      "6",
      "6 5/8",
      '6 5/8" 30',
      "7",
      "7 5/8",
      "7 3/4",
      "8",
      "8 5/8",
      "9 3/8",
      "9 5/8",
      "9 7/8",
      "10",
      "10 1/8",
      "10 1/4",
      "10 3/4",
      "11 3/4",
      "12",
      "12 3/4",
      "13 3/8",
      "13 5/8",
      "14",
      "16",
      "17 7/8",
      "18",
      "18 5/8",
      "20",
      "22",
      "24",
      "24 1/2",
      "27 11/11",
      "28",
      "30",
      "32",
      "36",
      "40",
      "42",
      "48",
      "78 3/4",
    ];
    const pipe_material = facets["pipe.pipe_material"] && Object.keys(facets["pipe.pipe_material"]);
    const cat = _.take(facets["categories.lvl0"] && Object.keys(facets["categories.lvl0"]), 6);
    const subCat = _.take(facets["categories.lvl1"] && Object.keys(facets["categories.lvl1"]), 6);
    const makefilter = facets["make"] && Object.keys(facets["make"]);
    const modelfilter = _.take(facets["model"] && Object.keys(facets["model"]), 6);
    const regionfilter = facets["region"] && Object.keys(facets["region"]);

    const activeFilters = [...catagory, ...catagory1, ...make, ...model, ...region];
    const showFilters = _.take(activeFilters, this.state.filtersShow);
    const ModifiedPipeMilCart = [];
    if (pipeMillCert.length === 2) {
      pipeMillCert.find((v) => v === "No") ? ModifiedPipeMilCart.push("No") : ModifiedPipeMilCart.push("Yes");
    } else if (pipeMillCert.length === 4) {
      ModifiedPipeMilCart.push("No");
      ModifiedPipeMilCart.push("Yes");
    }

    return (
      <div class="fc-sidebar d-none d-lg-block">
        {/* <ReactTooltip
          style={{
            padding: "15px",
            borderRadius: "4px",
            border: "0!important",
            width: "25% !important",
          }}
          html={true}
          data-html={true}
          place="top"
          type="dark"
          effect="solid"
        /> */}
        <div class="fc-sidebar-inner fc-sidebar-inner-unset">
          {activeFilters.length !== 0 && (
            <div class="filter-tags-container">
              <div class="ftc-head d-flex align-items-center justify-content-between">
                {loadingMain ? <Skeleton width={100} height={15} /> : <h4>Filters</h4>}
                {loadingMain ? (
                  <Skeleton width={100} height={15} />
                ) : (
                  <button
                    type="button"
                    class="clear-filter-text"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.clearFilter("all");
                    }}
                  >
                    Clear filters
                  </button>
                )}
              </div>
              {!loadingMain &&
                ((pipeType && pipeType.length > 0) ||
                  (pipeCondition && pipeCondition.length > 0) ||
                  (make && make.length > 0) ||
                  (region && region.length > 0) ||
                  (saleType && saleType.length > 0) ||
                  (pipeSize && pipeSize.length > 0) ||
                  (pipeMaterial && pipeMaterial.length > 0) ||
                  (pipeMillCert && pipeMillCert.length > 0)) && (
                  <div class="filter-tags">
                    <div class="tags">
                      {saleType.map((f, i) => (
                        <span class="badge">
                          Sale Type:{" "}
                          {f === "Wanted Pipe (Sell Pipe)" ? "Operator Procurement Request " : " Surplus Pipe For Sale"}
                          <img
                            class="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "saleType");
                            }}
                          />
                        </span>
                      ))}
                      {pipeType.map((f, i) => (
                        <span class="badge">
                          Pipe Type: {f}
                          <img
                            class="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "pipeType");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {ModifiedPipeMilCart.length === 1
                        ? ModifiedPipeMilCart.map((f, i) =>
                            f === "No" ? (
                              <span class="badge">
                                Mill Test Report: No
                                <img
                                  class="tag-close-icon"
                                  src={closeIcon}
                                  alt="close"
                                  onClick={(e) => {
                                    removeFilter(f, "pipeMillCert");
                                    removeFilter("false", "pipeMillCert");
                                  }}
                                />
                              </span>
                            ) : (
                              <span class="badge">
                                Mill Test Report: Yes
                                <img
                                  class="tag-close-icon"
                                  src={closeIcon}
                                  alt="close"
                                  onClick={(e) => {
                                    removeFilter(f, "pipeMillCert");
                                    removeFilter("true", "pipeMillCert");
                                  }}
                                />
                              </span>
                            ),
                          )
                        : ModifiedPipeMilCart.length === 2 && (
                            <>
                              <span class="badge">
                                Mill Test Report: No
                                <img
                                  class="tag-close-icon"
                                  src={closeIcon}
                                  alt="close"
                                  onClick={(e) => {
                                    removeFilter("No", "pipeMillCert");
                                    removeFilter("false", "pipeMillCert");
                                  }}
                                />
                              </span>
                              <span class="badge">
                                Mill Test Report: Yes
                                <img
                                  class="tag-close-icon"
                                  src={closeIcon}
                                  alt="close"
                                  onClick={(e) => {
                                    removeFilter("Yes", "pipeMillCert");
                                    removeFilter("true", "pipeMillCert");
                                  }}
                                />
                              </span>
                            </>
                          )}{" "}
                      {pipeCondition.map((f, i) => (
                        <span class="badge">
                          Pipe Condition: {f}
                          <img
                            class="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "pipeCondition");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {make.map((f, i) => (
                        <span class="badge">
                          Manufacturer: {f}
                          <img
                            class="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "make");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {pipeMaterial.map((f, i) => (
                        <span class="badge">
                          Pipe Material: {f}
                          <img
                            class="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "pipeMaterial");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {pipeSize.map((f, i) => (
                        <span class="badge">
                          Pipe Size: {f}
                          <img
                            class="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "pipeSize");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {region.map((f, i) => (
                        <span class="badge">
                          Region: {f}
                          <img
                            class="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "region");
                            }}
                          />
                        </span>
                      ))}
                    </div>
                  </div>
                )}
            </div>
          )}
          <Accordion className="accordion product-type-accordion" activeKey={this.state.defaultActiveKey}>
            {loadingMain ? (
              <Accordion.Item eventKey="0">
                <div style={{ margin: "10px 30px" }}>
                  <Skeleton width="100%" height={15} />
                </div>
              </Accordion.Item>
            ) : (
              sale_type &&
              sale_type.length > 0 && (
                <Accordion.Item eventKey="0">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("0");
                    }}
                  >
                    Sale Type
                  </Accordion.Header>
                  <Accordion.Body key={saleType.length}>
                    {saleType.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        class="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("saleType");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {sale_type.map((v) => (
                      <div class="form-check d-flex align-items-center">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id={v}
                          checked={saleType.find((ev) => ev === v) ? true : false}
                        />
                        <label class="form-check-label" for={v} onClick={() => this.props.setData("saleType", v)}>
                          {`${
                            v === "Wanted Pipe (Sell Pipe)"
                              ? "Operator Procurement Request "
                              : " Surplus Pipe For Sale "
                          } (${facets["pipe.sale_type"][v]})`}
                        </label>
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              )
            )}
            {loadingMain ? (
              <Accordion.Item eventKey="5">
                <div style={{ margin: "10px 30px" }}>
                  <Skeleton width="100%" height={15} />
                </div>
              </Accordion.Item>
            ) : (
              pipe_size &&
              pipe_size.length > 0 && (
                <Accordion.Item eventKey="5">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("5");
                    }}
                  >
                    Size
                  </Accordion.Header>
                  <Accordion.Body key={pipeSize.length}>
                    {pipeMillCert.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        class="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("pipeSize");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {process.env.GATSBY_APP_MODE == "dev"
                      ? pipe_size_asc_dev?.map((v) =>
                          facets["pipe.pipe_size"][v] ? (
                            <div class="form-check d-flex align-items-center">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={pipeSize.find((ev) => ev === v) ? true : false}
                              />
                              <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeSize", v)}>
                                {`${v} (${facets["pipe.pipe_size"][v] ? facets["pipe.pipe_size"][v] : 0})`}
                              </label>
                            </div>
                          ) : (
                            ""
                          ),
                        )
                      : pipe_size_asc_prod?.map((v) =>
                          facets["pipe.pipe_size"][v] ? (
                            <div class="form-check d-flex align-items-center">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={pipeSize.find((ev) => ev === v) ? true : false}
                              />
                              <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeSize", v)}>
                                {`${v} (${facets["pipe.pipe_size"][v] ? facets["pipe.pipe_size"][v] : 0})`}
                              </label>
                            </div>
                          ) : (
                            ""
                          ),
                        )}
                  </Accordion.Body>
                </Accordion.Item>
              )
            )}
            {/* {sale_type && sale_type.length > 0 && (
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  onClick={(e) => {
                    this.handleToggle("0");
                  }}
                >
                  Sale Type
                </Accordion.Header>
                <Accordion.Body key={saleType.length}>
                  {saleType.length > 0 && (
                    <a
                      href="javascript:void(0)"
                      class="clearall-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.clearFilter("saleType");
                      }}
                    >
                      Clear all
                    </a>
                  )}
                  {sale_type.map((v) => (
                    <div class="form-check d-flex align-items-center">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={v}
                        checked={saleType.find((ev) => ev === v) ? true : false}
                      />
                      <label class="form-check-label" for={v} onClick={() => this.props.setData("saleType", v)}>
                        {`${v} (${facets["pipe.sale_type"][v]})`}
                      </label>
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            )} */}
            {loadingMain ? (
              <Accordion.Item eventKey="1">
                <div style={{ margin: "10px 30px" }}>
                  <Skeleton width="100%" height={15} />
                </div>
              </Accordion.Item>
            ) : (
              pipe_type &&
              pipe_type.length > 0 && (
                <Accordion.Item eventKey="1">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("1");
                    }}
                  >
                    Pipe Type
                  </Accordion.Header>
                  <Accordion.Body key={catagory1.length}>
                    {pipeType.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        class="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("pipeType");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {pipe_type.map((v) => (
                      <div class="form-check d-flex align-items-center">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id={v}
                          checked={pipeType.find((ev) => ev === v) ? true : false}
                        />
                        <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeType", v)}>
                          {`${v} (${facets["pipe.pipe_type"][v]})`}
                        </label>
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              )
            )}
            {loadingMain ? (
              <Accordion.Item eventKey="2">
                <div style={{ margin: "10px 30px" }}>
                  <Skeleton width="100%" height={15} />
                </div>
              </Accordion.Item>
            ) : (
              pipe_condition &&
              pipe_condition.length > 0 && (
                <Accordion.Item eventKey="2">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("2");
                    }}
                  >
                    Pipe Condition
                  </Accordion.Header>
                  <Accordion.Body key={pipeCondition.length}>
                    {pipeCondition.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        class="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("pipeCondition");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {pipe_condition.map((v) => (
                      <div class="form-check d-flex align-items-center">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id={v}
                          checked={pipeCondition.find((ev) => ev === v) ? true : false}
                        />
                        <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeCondition", v)}>
                          {`${v} (${facets["pipe.pipe_condition"][v]})`}
                        </label>
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              )
            )}

            {loadingMain ? (
              <Accordion.Item eventKey="3">
                <div style={{ margin: "10px 30px" }}>
                  <Skeleton width="100%" height={15} />
                </div>
              </Accordion.Item>
            ) : (
              pipe_mill_cert &&
              pipe_mill_cert.length > 0 && (
                <Accordion.Item eventKey="3">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("3");
                    }}
                  >
                    Mill Test Reports
                  </Accordion.Header>
                  <Accordion.Body key={pipeMillCert.length}>
                    {pipeMillCert.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        class="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("pipeMillCert");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {["No", "Yes"].map((v) => (
                      <div class="form-check d-flex align-items-center">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id={v}
                          checked={pipeMillCert.find((ev) => ev === v) ? true : false}
                        />
                        <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeMillCert", v)}>
                          {`${v} (${v === "No" ? facets["pipe.pipe_mill_cert"][v] : facets["pipe.pipe_mill_cert"][v]})`}
                        </label>
                      </div>
                    ))}
                    {/* {pipe_mill_cert.map(v => (
                    <div class="form-check d-flex align-items-center">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={v}
                        checked={
                          pipeMillCert.find(ev => ev === v) ? true : false
                        }
                      />
                      <label
                        class="form-check-label"
                        for={v}
                        onClick={() => this.props.setData("pipeMillCert", v)}
                      >
                        {`${v} (${facets["pipe.pipe_mill_cert"][v]})`}
                      </label>
                    </div>
                  ))} */}
                  </Accordion.Body>
                </Accordion.Item>
              )
            )}
            {loadingMain ? (
              <Accordion.Item eventKey="4">
                <div style={{ margin: "10px 30px" }}>
                  <Skeleton width="100%" height={15} />
                </div>
              </Accordion.Item>
            ) : (
              pipe_material &&
              pipe_material.length > 0 && (
                <Accordion.Item eventKey="4">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("4");
                    }}
                  >
                    Pipe Material
                  </Accordion.Header>
                  <Accordion.Body key={pipeMaterial.length}>
                    {pipeMaterial.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        class="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("pipeMaterial");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {pipe_material.map((v) => (
                      <div class="form-check d-flex align-items-center">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id={v}
                          checked={pipeMaterial.find((ev) => ev === v) ? true : false}
                        />
                        <label class="form-check-label" for={v} onClick={() => this.props.setData("pipeMaterial", v)}>
                          {`${v} (${facets["pipe.pipe_material"][v]})`}
                        </label>
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              )
            )}

            {loadingMain ? (
              <Accordion.Item eventKey="6">
                <div style={{ margin: "10px 30px" }}>
                  <Skeleton width="100%" height={15} />
                </div>
              </Accordion.Item>
            ) : (
              makefilter &&
              makefilter.length > 0 && (
                <Accordion.Item eventKey="6">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("6");
                    }}
                  >
                    Manufacturer
                  </Accordion.Header>
                  <Accordion.Body key={pipeSize.length}>
                    {make.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        class="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("make");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {makefilter.map((v) => (
                      <div class="form-check d-flex align-items-center">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id={v}
                          checked={make.find((ev) => ev === v) ? true : false}
                        />
                        <label class="form-check-label" for={v} onClick={() => this.props.setData("make", v)}>
                          {`${v} (${facets["make"][v]})`}
                        </label>
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              )
            )}

            {loadingMain ? (
              <Accordion.Item eventKey="7">
                <div style={{ margin: "10px 30px" }}>
                  <Skeleton width="100%" height={15} />
                </div>
              </Accordion.Item>
            ) : (
              regionfilter &&
              regionfilter.length > 0 && (
                <Accordion.Item eventKey="7">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("7");
                    }}
                  >
                    Region
                  </Accordion.Header>
                  <Accordion.Body>
                    {region.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        class="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("region");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {regionfilter.map((v) => (
                      <div class="form-check d-flex align-items-center">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id={v}
                          checked={region.find((ev) => ev === v) ? true : false}
                        />
                        <label class="form-check-label" for={v} onClick={() => this.props.setData("region", v)}>
                          {`${v} (${facets["region"][v]})`}
                        </label>
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              )
            )}

            {loadingMain ? (
              <Accordion.Item eventKey="7">
                <div style={{ margin: "10px 30px" }}>
                  <Skeleton width="100%" height={15} />
                </div>
              </Accordion.Item>
            ) : (
              <Accordion.Item eventKey="8">
                <Accordion.Header
                  onClick={(e) => {
                    this.handleToggle("8");
                  }}
                >
                  Pipe Calculator{" "}
                  {/* <div
                    class="help-icon"
                    data-tip="
                                    <h6 style='margin-bottom:0px;font-size: 0.75rem;font-weight: 700;'>Calculate Weight or Wall Thickness</h6>
                                    <p style='font-size: 0.75rem;font-weight: 400;'>Enter the Outside Diameter; And Weight or Wall Thickness</p>

                                    <h6 style='margin-bottom:0px;font-size: 0.75rem;font-weight: 700;'>Calculate Total Length, Total Weight, and Est. Scrap Price</h6>
                                    <p style='font-size: 0.75rem;font-weight: 400;'>Enter Length of Pipe and Number of Pipes to Calculate Total Length, Total Weight, and Estimated Scrap Price</p>

                                    <h6 style='margin-bottom:0px;font-size: 0.75rem;font-weight: 700;'>Units :</h6>
                                    <p style='margin-bottom: 8px; font-size: 0.75rem;font-weight: 400;'>OD in Milimeters (244.48 mm or 298.45mm)<br />
                                    Pounds per Foot (i.e 53.5 lb/ft or 65 lbs/ft)<br />
                                    Kilograms/ Meter (i.e 79.62 kg/m or 96.73 kg/m)<br />
                                    WT of the Pipe in Milimeters ( 14.02mm or 13.79mm)<br />
                                    Scrap Price- (If Nothing is Entered Estimate is $200/MT) *All calculations are estimates and for indicative use only</p>
                                "
                    ata-html={true}
                    html={true}
                  >
                    <img src={helpIcon} alt="" />
                  </div> */}
                </Accordion.Header>
                <Accordion.Body>
                  <a href="javascript:void(0)" class="calculate-link">
                    Calculate Pounds per Foot or Wall Thickness
                  </a>
                  <div class="form-group">
                    <label for="size" class="form-label">
                      Size of Outer Diameter
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="size"
                      value={this.state.od}
                      onChange={(e) => this.setState({ od: e.target.value })}
                    />
                  </div>
                  <div class="form-group">
                    <label for="" class="form-label">
                      Weight of Pipe
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Recipient's username"
                        aria-describedby="calculate"
                        value={this.state.weight}
                        onChange={(e) => this.setState({ weight: e.target.value })}
                      />
                      <span
                        style={{ cursor: "pointer" }}
                        class="input-group-text"
                        onClick={() => this.calculateWeightOf()}
                      >
                        Calculate
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="" class="form-label">
                      Wall Thickness of Pipe
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Recipient's username"
                        aria-describedby="calculate"
                        value={this.state.wt}
                        onChange={(e) => this.setState({ wt: e.target.value })}
                      />
                      <span
                        style={{ cursor: "pointer" }}
                        class="input-group-text"
                        id="calculate"
                        onClick={this.calculateWt}
                      >
                        Calculate
                      </span>
                    </div>
                  </div>
                  <div class="partition"></div>
                  <a href="javascript:void(0)" class="calculate-link">
                    Calculate Total Length, Total Weight, and Estimated Scrap Price
                  </a>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="length" class="form-label">
                          Length of each Joint
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="length"
                          value={this.state.length}
                          onChange={(e) => this.setState({ length: e.target.value })}
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="totalNumber" class="form-label">
                          Total Number of Pipes
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="totalNumber"
                          value={this.state.nrofPipes}
                          onChange={(e) => this.setState({ nrofPipes: e.target.value })}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="calcluateTotal" class="form-label">
                      Calcluate Total Length
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Recipient's username"
                        aria-describedby="calcluateTotal"
                        value={this.state.totalLength}
                        onChange={(e) => this.setState({ totalLength: e.target.value })}
                      />
                      <span
                        class="input-group-text"
                        id="calcluateTotal"
                        style={{ cursor: "pointer" }}
                        onClick={this.calctotalLength}
                      >
                        Calculate
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="calculateAverage" class="form-label">
                      Calcluate Average Joint Length
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Recipient's username"
                        aria-describedby="calculateAverage"
                        value={this.state.averageJoin}
                      />
                      <span
                        class="input-group-text"
                        id="calculateAverage"
                        style={{ cursor: "pointer" }}
                        onClick={this.calctotalJoin}
                      >
                        Calculate
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="calculateWeight" class="form-label">
                      Calcluate Total Weight
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Recipient's username"
                        aria-describedby="calculateWeight"
                        value={this.state.totalWeight}
                      />
                      <span
                        class="input-group-text"
                        id="calculateWeight"
                        style={{ cursor: "pointer" }}
                        onClick={this.calculateTotalWeight}
                      >
                        Calculate
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="scrap" class="form-label">
                      Scrap
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="scrap"
                      value={this.state.scrap}
                      onChange={(e) => this.setState({ scrap: e.target.value })}
                    />
                  </div>
                  <div class="form-group">
                    <label for="scrapPrice" class="form-label">
                      Estimated Scrap Price
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Recipient's username"
                        aria-describedby="scrapPrice"
                        value={this.state.totalScrap}
                      />
                      <span
                        class="input-group-text"
                        id="scrapPrice"
                        style={{ cursor: "pointer" }}
                        onClick={this.calculateScrap}
                      >
                        Calculate
                      </span>
                    </div>
                  </div>
                  <div class="partition"></div>
                  <div class="graph" id="xom">
                    <script
                      type="text/javascript"
                      src="https://www.barchart.com/widget.js?uid=7c97d40cc2f911361b1bb3050a800ab4&widgetType=chart&showChart=true&widgetWidth=214&chartType=AREA&chartColor[area]=46ad1d&fontColor[links]=46ad1d&font=1&animated=1&symbols[]=xom&fields[]=name&fields[]=last&fields[]=change&displayChars"
                    ></script>
                    {/* <img src={graphImg} alt="" /> */}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
        </div>
      </div>
    );
  }
}

export default pipeFilterSidebar;
